import React from "react";

import { mdiTriangleSmallUp } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import { MEDIA_FORMATS_AD_BREAKS } from "../../../constants/media";
import Block from "../../block/Block";
import Input from "../../form/Input";

import type { JSX } from "react";

import type { MediaFormat } from "../../../constants/media";

interface MediaType {
  label: string;
  key: MediaFormat;
}

interface MediaTypesSectionProps {
  mediaTypeList: MediaType[];
  title: string;
}

function MediaTypesSection({
  mediaTypeList,
  title,
}: MediaTypesSectionProps): JSX.Element {
  const renderLabel = (label: string): JSX.Element => (
    <div className="font-medium">
      <Icon
        className="mr-[0.3125rem] inline"
        path={mdiTriangleSmallUp}
        rotate={90}
        size={0.9375}
      />
      {label}
    </div>
  );
  return (
    <div className="flex flex-col">
      <p className="mb-[1.875rem] text-[1.171875rem] font-semibold">{title}</p>
      {mediaTypeList.map((mediaType) => (
        <Input
          key={mediaType.key}
          label={renderLabel(mediaType.label)}
          name={`mediaColors.${mediaType.key}`}
          type="color"
        />
      ))}
    </div>
  );
}

interface MediaTypeSettingsProps {
  mediaTypeList: MediaType[];
}

function MediaTypeSettings({
  mediaTypeList,
}: MediaTypeSettingsProps): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  const mediaTypeSections = mediaTypeList?.reduce(
    (acc: { program: MediaType[]; adBreak: MediaType[] }, mediaType) => {
      if (MEDIA_FORMATS_AD_BREAKS.includes(mediaType.key)) {
        acc.adBreak.push(mediaType);
      } else {
        acc.program.push(mediaType);
      }
      return acc;
    },
    { program: [], adBreak: [] },
  );

  return (
    <Block title={t("mediaTypeSettings")}>
      <MediaTypesSection
        mediaTypeList={mediaTypeSections.program}
        title={t("programs")}
      />
      <MediaTypesSection
        mediaTypeList={mediaTypeSections.adBreak}
        title={t("adBreaks")}
      />
    </Block>
  );
}

export default MediaTypeSettings;
